
    import {Component, Vue} from "vue-property-decorator";
    import IHelpData from "@/types/helpData.interface";
    import sesService from "@/services/ses.service";
    import "@aws-amplify/ui-vue";
    import FileDragAndDrop from "@/components/utils/FileDragAndDrop.vue"
    import {namespace} from "vuex-class";

    const userModule = namespace("userModule");
    @Component({
        components: {
            FileDragAndDrop
        },
    })
    export default class Contact extends Vue {
        @userModule.State
            public user!: any;

        lastname=null;
        firstname=null;
        tel= null;
        obj= null;
        message= null;
        file= null;
        contact_errors: string[] =[];
        snackbar = false;
        uploadedFiles = [];

      checkForm(e) {
        this.contact_errors = [];
        if (!this.lastname || !this.tel || !this.obj || !this.message) {
          this.contact_errors.push("Merci de remplir la totalité des champs obligatoires.");
          e.preventDefault();
        } else {
          const params: IHelpData = {
            lastname: this.lastname,
            firstname: this.firstname,
            tel: this.tel,
            obj: this.obj,
            message: this.message,
          };
          sesService.sendHelp(params, this.user.email);
          this.lastname = null;
          this.firstname = null;
          this.tel = null;
          this.obj = null;
          this.message = null;
          //this.contactDisplay();
          this.$emit('contactDisplay');
          this.$emit('displaySnackBar');
          e.preventDefault();
          //this.snackbar = true;
        }
      }

      onClickOutside() {
        this.$emit('contactDisplay');
      }


    }
